/*
  Маршруты кабинета с проверкой прав (аудит 28.10.2026, раздел 5.3).

  Вынесены из `App.jsx`: там остаётся вход, проверка сессии и каркас. Каждый раздел обёрнут
  охранником `RouteGate`: нужное разрешение берётся из того же перечня, что у меню
  (`sections.js`), поэтому меню и адресная строка не расходятся. Закрытый адрес уводит на
  стартовую страницу роли, а не показывает экран с отказами.
*/

import { Navigate, Route, Routes } from 'react-router-dom'

import RouteGate from '../components/RouteGate.jsx'
import { needOf, OFF_MENU_NEEDS } from '../components/sections.js'
import AccountNewPage from './AccountNewPage.jsx'
import AccountPage from './AccountPage.jsx'
import CommunicationPage from './CommunicationPage.jsx'
import CommunicationsPage from './CommunicationsPage.jsx'
import ConveyorPage from './ConveyorPage.jsx'
import DashboardPage from './DashboardPage.jsx'
import DebtFormationPage from './DebtFormationPage.jsx'
import EnforcementPage from './EnforcementPage.jsx'
import ImportPage from './ImportPage.jsx'
import RadarPage from './RadarPage.jsx'
import RegistryFindingsPage from './RegistryFindingsPage.jsx'
import RegistryPage from './RegistryPage.jsx'
import ReportsPage from './ReportsPage.jsx'
import SettingsPage from './SettingsPage.jsx'
import UsagePage from './UsagePage.jsx'

export default function CabinetRoutes({ profile, start, onBurning }) {
  const guarded = (path, element, need = needOf(path)) => (
    <Route
      path={path}
      element={
        <RouteGate profile={profile} need={need} start={start}>
          {element}
        </RouteGate>
      }
    />
  )
  return (
    <Routes>
      {guarded('/dashboard', <DashboardPage onBurning={onBurning} profile={profile} />)}
      {guarded('/registry', <RegistryPage profile={profile} onBurning={onBurning} />)}
      {/* «new» раньше параметра: иначе слово «new» читалось бы как номер счёта. */}
      {guarded('/accounts/new', <AccountNewPage profile={profile} />, OFF_MENU_NEEDS.accounts)}
      {guarded('/accounts/:accountId', <AccountPage profile={profile} />, OFF_MENU_NEEDS.accounts)}
      {guarded('/accounts/:accountId/debt', <DebtFormationPage />, OFF_MENU_NEEDS.accounts)}
      {guarded('/conveyor', <ConveyorPage profile={profile} />)}
      {guarded('/import', <ImportPage />)}
      {guarded('/usage', <UsagePage />)}
      {guarded('/radar', <RadarPage />)}
      {guarded('/registry-findings', <RegistryFindingsPage />, OFF_MENU_NEEDS.findings)}
      {guarded('/enforcement', <EnforcementPage profile={profile} />)}
      {guarded('/communications', <CommunicationsPage />)}
      {/* Одно обращение. Отдельным адресом, а не раскрытием строки: на него
          ведут и список последних обращений, и лента движения дела на
          карточке счёта, и ссылку на разговор можно передать. */}
      {guarded('/communications/:communicationId', <CommunicationPage />, OFF_MENU_NEEDS.communication)}
      {guarded('/reports', <ReportsPage />)}
      {guarded('/settings', <SettingsPage profile={profile} />)}
      <Route path="/login" element={<Navigate to={start} replace />} />
      <Route path="*" element={<Navigate to={start} replace />} />
    </Routes>
  )
}
